export default "__VITE_ASSET__DCqlEjWH__"